// export const api_base_url = process.env.REACT_APP_API_ENDPOINT
// export const api_base_url = `http://127.0.0.1:8000/api/`  // -> local
// export const api_base_url = 'http://conceptor.localhost/api/' // -> local
// export const api_base_url = `https://staging-api.conceptor.ai/api/` // -> test server
export const api_base_url = `https://api.conceptor.ai/api/`  // -> prod server